var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVirtualdispensary1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2561_1599)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.58105 20.6637L10.0675 17.7598",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8788 20.6641H8.12207",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9326 17.7598L15.4191 20.6637",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6892 0.335938H1.31086C0.773505 0.335938 0.337891 0.769321 0.337891 1.30393V16.7918C0.337891 17.3264 0.773505 17.7598 1.31086 17.7598H23.6892C24.2266 17.7598 24.6622 17.3264 24.6622 16.7918V1.30393C24.6622 0.769321 24.2266 0.335938 23.6892 0.335938Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.337891 14.8555H24.6622",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.58121 12.9192C9.84989 12.9192 10.0677 12.7025 10.0677 12.4352C10.0677 12.1679 9.84989 11.9512 9.58121 11.9512C9.31253 11.9512 9.09473 12.1679 9.09473 12.4352C9.09473 12.7025 9.31253 12.9192 9.58121 12.9192Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4191 12.9192C15.6878 12.9192 15.9056 12.7025 15.9056 12.4352C15.9056 12.1679 15.6878 11.9512 15.4191 11.9512C15.1504 11.9512 14.9326 12.1679 14.9326 12.4352C14.9326 12.7025 15.1504 12.9192 15.4191 12.9192Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.09438 10.9849H15.9052C16.4412 10.9849 16.8782 10.5502 16.8782 10.0169C16.8782 9.48363 16.4412 9.04893 15.9052 9.04893H8.6079L7.14844 4.20898H15.4187",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8242 2.27148H17.608L15.9053 9.04741",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2561_1599"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirtualdispensary1);
export default __webpack_public_path__ + "static/media/virtualdispensary1.cbd7dd3265a6ee1b9ceee0b10e0e8d09.svg";
export { ForwardRef as ReactComponent };